import { GetInfos } from "../../endpoints/information/GetInformationService";
import { saveCard } from "./src/save-card";

export async function SendPipeData(params) {
  const infos = (await GetInfos())?.data?.[0]?.attributes;
  const config = {
    pipeId: infos.api_pipefy_pipeid_lead_data,
    phaseId: infos.api_pipefy_fase_lead_data,
    pipeToken: infos.api_pipefy_key,
    pipeUrl: infos.api_pipefy_url,
    pipeType: 'data',
  }
  const result = await saveCard({ params, config });
  return result;
}

// Listar fases
// {
//   pipe(id:303870166){
//     phases{
//       name
//       id
//     }
//   }
// }

// Move card de fase
// mutation{
//   moveCardToPhase(input:{
//     card_id: 1,
//     destination_phase_id: 1
//   }){
//     clientMutationId
//   }
// }
